import React from 'react';
import PropTypes from 'prop-types';
import css from './Duration.css';
import RadioGroup from '../RadioGroup';

export default class Duration extends React.Component {

  formatTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const totalHoursText = `${hours} hour${hours > 1 ? 's' : ''}`;
    const remainingMinutesText = `${minutes % 60} minute${minutes % 60 > 1 ? 's' : ''}`;
    if ( hours === 0 ) return remainingMinutesText;
    if ( minutes % 60 === 0 ) return totalHoursText;    
    return `${totalHoursText} and ${remainingMinutesText}`;
  }

  get options() {
    return this.props.durationsMinutes
      .map(duration => ({ name: this.formatTime(duration), id: duration }));
  }

  render() {
    return (
      <div className={css['content']}>
        <div>How long do you want to meet for?</div>
        <RadioGroup
          name="change-duration-radio"
          options={this.options}
          value={this.props.value}
          onSelectOption={this.props.onDurationSelected}
        />
      </div>
    );
  }
}

Duration.propTypes = {
  durationsMinutes: PropTypes.arrayOf(PropTypes.number).isRequired,
  value: PropTypes.number.isRequired,
  onDurationSelected: PropTypes.func.isRequired
};
